export const selectAllEmployeeCalendarAvailability = state =>
	state.employeeCalendarAvailability?.data || [];

export const selectEmployeeCalendarAvailability = propertyCode => state =>
	state.employeeCalendarAvailability?.data[propertyCode];
